module.exports = __webpack_public_path__ + "static/media/consultation_image.65031c27.jpg";